export const SHOW_ATTENDEES_MODAL = 'SHOW_ATTENDEES_MODAL'
export const CLOSE_ATTENDEES_MODAL = 'CLOSE_ATTENDEES_MODAL'

export const showAttendeesModal = (attendees) => ({
  type: SHOW_ATTENDEES_MODAL,
	attendees: attendees
})

export const closeAttendeesModal = () => ({
  type: CLOSE_ATTENDEES_MODAL
})



// WEBPACK FOOTER //
// ./src/actions/attendees.js